import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";


import CpntDragAndDropLists from "../../../components/CpntDragAndDropLists";
import { useBOSocieteUpdateMarquesMutation, useSearchBOSocieteMarquesQuery, useFetchBOSocieteMarquesQuery } from "../../../redux/slice/api/BO/societeApi";
import { ISocieteUpdateMarques } from "../../../models/interfaces/ISociete";
import { IKeyValueLibelle } from "../../../models/interfaces/IKeyValueLibelle";
import { IFilterMarquesSearch, getDefaultFilterMarques,filterToQuery, dtoToFilter } from "../../../models/interfaces/IFilterMarquesSearch";
import { IMarque } from "../../../models/interfaces/IMarques";
import { toast } from "react-toastify";
import CompteSocieteMarquesFilter from "./CompteSocieteMarquesFilter";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";


interface IProps {
  IdSociete: number;
  refetch: boolean;
}


const BOCompteSocieteTabMarques: React.FC<IProps> = ({ IdSociete,refetch }) => {

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
 

  const [listfilterMarques, setListFilterMarques] = useState<IFilterMarquesSearch>(getDefaultFilterMarques());
  const [searchParamsMarques, setSearchParamsMarques] = useState<IFilterMarquesSearch>(getDefaultFilterMarques());
  const applyFilterMarques = (data: IFilterMarquesSearch) => {
    setListFilterMarques(data);
  }


  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterMarquesSearch");
    if (storedFilter !== null && storedFilter !== undefined) {
      setListFilterMarques(JSON.parse(storedFilter));
    }
  }, []);

  useEffect(() => {
    if (IdSociete && listfilterMarques) {
      const _filter: IFilterMarquesSearch = filterToQuery({
        ...listfilterMarques,
        IdSociete: IdSociete,
      });
      setSearchParamsMarques(_filter);
    }
  }, [IdSociete, listfilterMarques]);


  /*Marques */
  const [sourceMarques, setSourceMarques] = useState<IKeyValueLibelle[]|undefined>([]);
  const [destinationMarques, setDestinationMarques] = useState<IKeyValueLibelle[]|undefined>([]);
  const [destinationMarquesResult, setDestinationMarquesResult] = useState<IKeyValueLibelle[]|null>(null);

  //const [fetchSearchMarques, setFetchSearchMarques] = useState(refetch);
  const [fetchSocieteMarques, setFetchSocieteMarques] = useState(refetch);

  //Recherche Marques
  const { data: SearchMarquesResult, isFetching: SearchMarquesisFetching, error: SearchMarqueserror} = useSearchBOSocieteMarquesQuery(searchParamsMarques, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParamsMarques === null || searchParamsMarques === undefined || searchParamsMarques?.SearchLibelle === undefined || searchParamsMarques?.SearchLibelle === "", //|| fetchSearchMarques === false
  });

  //Marques affectés a la societe
  const { data: SocieteMarquesResult, isFetching: SocieteMarquesisFetching, error: SocieteMarqueserror,refetch:refetchBOSocieteMarques } = useFetchBOSocieteMarquesQuery(IdSociete, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || IdSociete === 0 || fetchSocieteMarques === false,
  });


  useEffect(() => {
    //setFetchSearchMarques(refetch);
    setFetchSocieteMarques(refetch);
  }, [refetch])



  const [
    BOSocieteUpdateMarques,
    {
    isSuccess: isSuccessUpdateMarques,
    error: errorBOSocieteUpdateMarques,
    isLoading:isLoadingUpdateMarques
  }] = useBOSocieteUpdateMarquesMutation();


  const PaintSourceMarques = () => {
    setSourceMarques([]);

    const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

    SearchMarquesResult?.Marques?.forEach((elem: IMarque) => {
      Tasks.push({
        value: elem.IdExterne?.toString(), //IdCalipse
        key: elem.IdExterne?.toString(), //IdCalipse
        Libelle: elem.Libelle 
      });
    });
    
    setSourceMarques(Tasks);

  }

  const PaintDestinationMarques = () => {
    setDestinationMarques([]);

    const Tasks: React.SetStateAction<IKeyValueLibelle[] | undefined> = [];

    SocieteMarquesResult?.Marques?.map((elem:IMarque) => {
      Tasks.push({
        value: elem.IdExterne?.toString(), //IdCalipse
        key: elem.IdExterne?.toString(), //IdCalipse
        Libelle: elem.Libelle 
      });
    });
    
    setDestinationMarques(Tasks);
  }

  const AnnulerMarquesCommand = () => {
    PaintDestinationMarques();
    PaintSourceMarques();
  }
 

  useEffect(() => {
    if (!SearchMarquesisFetching && !isLoadingUpdateMarques && SearchMarqueserror === undefined) {
      PaintSourceMarques();
    } else {
      setSourceMarques(undefined);
    }
  }, [SearchMarquesisFetching,SearchMarquesResult,isSuccessUpdateMarques])


  useEffect(() => {
    if (!SocieteMarquesisFetching && !isLoadingUpdateMarques && SocieteMarqueserror === undefined ) {
      PaintDestinationMarques();
    } else {
      setDestinationMarques(undefined);
    }
  }, [SocieteMarquesisFetching,SocieteMarquesResult,isSuccessUpdateMarques])


  useEffect(() => {
    if (errorBOSocieteUpdateMarques !== undefined) {
      toast.warn("Les modifications n'ont pas été prises en compte");
      refetchBOSocieteMarques();
    }
}, [errorBOSocieteUpdateMarques])

useEffect(() => {
  if (isSuccessUpdateMarques) {
    toast.success("Les modifications ont bien été prises en compte.");
    refetchBOSocieteMarques();
  }
}, [isSuccessUpdateMarques])

  useEffect(() => {

    if (destinationMarquesResult) {
      const result: ISocieteUpdateMarques = {
        IdSociete:  IdSociete,
        Marques: destinationMarquesResult?.map(m => ({
            IdExterne: parseInt(m.value),
            Libelle: m.Libelle,
        }))
    };
    BOSocieteUpdateMarques(result);
    }
  }, [destinationMarquesResult])

 
  return (
    <>
            <CompteSocieteMarquesFilter 
              filter={dtoToFilter(searchParamsMarques)}
              changeFilter={applyFilterMarques}
                />
          {isLoadingUpdateMarques
          ?
            <SpinnerEditeurPro text="Mise à jour en cours..." />
          : 
          <CpntDragAndDropLists 
          titresource="Votre recherche" 
          source={sourceMarques} 
          sourceIsFetching={SearchMarquesisFetching}
          titredestination="Fonds attribué" 
          destination={destinationMarques} 
          destinationIsFetching={SocieteMarquesisFetching} 
          cmdValider={setDestinationMarquesResult} 
          cmdAnnuler={AnnulerMarquesCommand} />
          } 
    </>
  )
    
}; 

export default BOCompteSocieteTabMarques;

